import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Container } from "react-bootstrap";

function AniketaHeartfeltJourneyVikashFoundation() {
  return (
    <>
      <Header />
      <main id="page-content" className="main-page">
        {/* Breadcrumbs */}
        <section
          className="position-relative text-white text-center"
          style={{ height: "400px" }}
        >
          <img
            src=""
            alt="A New Hope for Disabled Children"
            className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
          />
          <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>

          <Container className="position-relative d-flex flex-column justify-content-center align-items-center h-100">
            <h1 className="fw-bold display-5 mb-3">
              Success Story – Aniketa’s Journey with Vikash Foundation
            </h1>
          </Container>
        </section>
        <br></br>
        {/* Post Thumbnail */}
        <section className="post-thumbnail text-center">
          <img
            src="/images/story1.jpg"
            alt="Surfing man adventure"
            width={900}
            height={600}
            srcSet="
             /images/story1.jpg
            "
            sizes="(max-width: 900px) 100vw, 900px"
          />
        </section>

        <br></br>

        


        <section className="container my-5">
          <article className="post-content">
          <p>
            Aniketa, an 8-year-old boy from Gop, Puri, had a tough start in
            life. He found it difficult to perform daily activities, speak
            clearly, and walk properly. Fortunately, Vikash Foundation stepped
            in to provide the support he needed.
          </p>

          <h3>Recognizing the Challenges</h3>
          <p>
            From an early age, Aniketa struggled with developmental delays that
            affected his mobility, speech, and ability to manage daily tasks.
            These challenges required both medical and educational intervention.
          </p>

          <h3>Therapies and Support Provided</h3>
          <p>
            With the help of Vikash Foundation, Aniketa received{" "}
            <strong>physiotherapy, special therapy, tailored education,</strong>{" "}
            and additional assistance from the government. His mother played an
            active role by accompanying him to weekly therapy sessions, ensuring
            consistent practice and encouragement.
          </p>

          <h3>Inspiring Progress</h3>
          <p>
            Over time, Aniketa began to show improvements in walking,
            communication, and his ability to handle everyday tasks. His journey
            highlights how early intervention and family involvement can bring
            about meaningful progress for children with disabilities.
          </p>

          <p>
            Aniketa’s story is not unique; there are many children like him who
            face similar challenges. If you’re inspired by his journey and wish
            to make a difference, consider joining{" "}
            <strong>Vikash Foundation</strong>. Together, we can continue to
            provide life-changing support and care to children in need.
          </p>
        </article>
      </section>
        
      </main>
      <br></br>

      <Footer />
    </>
  );
}

export default AniketaHeartfeltJourneyVikashFoundation;
